import { Inject, NgZone, AfterViewInit, OnDestroy, Component, Input } from '@angular/core';
import { Project, BuildingFloor } from '../../../models/index';
import { MapPlanBase } from './map-plan-base.model';
import { ListTrackingService } from './../../../utils/list-tracking.service';

@Component({
  selector: 'app-map-plan-building-base',
  templateUrl: './map-plan-building-base.component.html'
})
export class MapPlanBuildingBaseComponent extends MapPlanBase implements AfterViewInit, OnDestroy {
  @Input() project: Project;
  @Input() buildingFloors: BuildingFloor[] = [];

  constructor(
    public zone: NgZone,
    @Inject('WINDOW') public window: any,
    public listTrackingService: ListTrackingService
  ) {
    super(zone, window)
  }

  ngAfterViewInit(): void {
    this.runImgMappingScript();
  }

  ngOnDestroy(): void {
    this.removeImgMappingScript();
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/map-plan/map-plan-building-base.component.ts